import { IconProductHighDemand16, IconProductCianLogo12, IconProductTrust16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { ELabelColor, TLabelColor } from '../../types/label';

export const labelIconMap: Record<ELabelColor, React.ReactElement<any> | undefined> = {
  [ELabelColor.Red]: undefined,
  [ELabelColor.Green]: undefined,
  [ELabelColor.DarkGreen]: undefined,
  [ELabelColor.Blue]: <IconProductCianLogo12 color="current_color" />,
  [ELabelColor.Gray]: undefined,
  [ELabelColor.DarkGray]: undefined,
  [ELabelColor.Yellow]: undefined,
  [ELabelColor.SimpleBlue]: undefined,
  [ELabelColor.DarkBlue]: undefined,
  [ELabelColor.BlackBlueGradient]: undefined,
  [ELabelColor.BlueVerifiedByCian]: <IconProductTrust16 color="icon-inverted-default" />,
  [ELabelColor.Purple]: <IconProductHighDemand16 color="current_color" />,
};

export function mapLabelIcon(color: TLabelColor): React.ReactElement<any> | undefined {
  return labelIconMap[color];
}
